import heartReaction from "../../images/reactions/heart-reaction.gif";
import hahaReaction from "../../images/reactions/haha-reaction.gif";
import likeReaction from "../../images/reactions/like-reaction.gif";
import thanksReaction from "../../images/reactions/thanks-reaction.png";
import sadReaction from "../../images/reactions/sad-reaction.gif";
import saluteReaction from "../../images/reactions/salute-reaction.gif";
import checkReaction from "../../images/reactions/check-reaction.gif";

import fireReaction from "../../images/reactions/fire-reaction.gif";
import snakeReaction from "../../images/reactions/snake-reaction.gif";
import chainReaction from "../../images/reactions/chain-reaction.gif";
import dollarReaction from "../../images/reactions/dollar-reaction.gif";
import armyReaction from "../../images/reactions/Army.gif";
import truckReaction from "../../images/reactions/trucking.gif";
import warehouseReaction from "../../images/reactions/warehouse.gif";
import moneybagReaction from "../../images/reactions/money-bag.gif";
import roosterReaction from "../../images/reactions/rooster.gif";
import vesselReaction from "../../images/reactions/vessel.gif";

import dragonReaction from "../../images/reactions/dragon-reaction.png";
import tigerReaction from "../../images/reactions/tiger-reaction.png";

import React, { useState, useRef, useEffect, useContext } from "react";
import { ChatContext, WebSocketContext } from "../../context/contexts";
import ApiService from "../../api/apiService";
import { common } from "../../util/common";
import showSwal from "../swal";

function ReactionOptions({
  chat_id,
  receiver,
  reaction,
  userDetails,
  toggleShowReactionOptions,
}) {
  const Chat = useContext(ChatContext);
  const WS = useContext(WebSocketContext);

  const [specificReactions, setSpecificReactions] = useState(null);

  const fetchSpecificReactions = async () => {
    const specificReactions =
      await ApiService.message.getUserSpecificReaction();

    if (specificReactions && specificReactions.success) {
      const reactions = specificReactions.user_specific_reactions.map(
        (u) => u.reaction_type,
      );
      setSpecificReactions(reactions);
    }
    console.log("specificReactions", specificReactions);
  };
  useEffect(() => {
    fetchSpecificReactions();
  }, []);

  const handleReactionClick = async (e) => {
    const target = e.target;

    const reactionType = target.getAttribute("reaction");

    const reactionResponse = await ApiService.message.addRemoveReaction(
      Chat.storedConversationId,
      chat_id,
      {
        reaction_type: reactionType,
      },
    );

    const { success, message_reaction } = reactionResponse;
    if (!success) return showSwal(common.errors.ADD_REMOVE_REACTION_ERROR);
    WS.websocketInstance.sendMsgReaction(
      { message: message_reaction, type: "user-reactions-chat" },
      Chat.storedConversationId,
    );
    toggleShowReactionOptions();
  };

  const isHahaReact = reaction?.haha?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isHeartReact = reaction?.heart?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isThanksReact = reaction?.thanks?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isLikeReact = reaction?.like?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isSadReact = reaction?.sad?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isSaluteReact = reaction?.salute?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isCheckReact = reaction?.checked?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );

  const isFireReact = reaction?.fire?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isSnakeReact = reaction?.snake?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isChainReact = reaction?.chain?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isDollarReact = reaction?.dollar?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isDragonReact = reaction?.dragon?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isTigerReact = reaction?.tiger?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isArmyReact = reaction?.army?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isTruckReact = reaction?.truck?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isWarehouseReact = reaction?.warehouse?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isMoneybagReact = reaction?.moneybag?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isRoosterReact = reaction?.rooster?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );
  const isVesselReact = reaction?.vessel?.find(
    (reactions) => reactions.user_id === userDetails.id,
  );

  return (
    <div className="modal-container">
      <div className="modal-dialog">
        <button
          className="close-btn"
          onClick={(e) => toggleShowReactionOptions()}
        >
          ✕
        </button>

        <div className="modal-msg-reactions">
          <h2 className="modal-title">Select Your Reaction</h2>
          <h3 className="reaction-title">Choose Your Reaction</h3>
          <div className="reaction-icons">
            <div
              className="reaction-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => handleReactionClick(e)}
              onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
              reaction="salute"
            >
              <img
                src={checkReaction}
                alt="Checked Reaction"
                reaction="checked"
                className={`like-reaction ${
                  isCheckReact ? "pulse pulse-bg" : ""
                }`}
              />
            </div>
            <div
              className="reaction-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => handleReactionClick(e)}
              onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
              reaction="heart"
            >
              <img
                src={heartReaction}
                alt="Heart Reaction"
                reaction="heart"
                className={`like-reaction ${
                  isHeartReact ? "pulse pulse-bg" : ""
                }`}
              />
            </div>
            <div
              className="reaction-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => handleReactionClick(e)}
              onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
              reaction="haha"
            >
              <img
                src={hahaReaction}
                alt="Haha Reaction"
                reaction="haha"
                className={`like-reaction ${
                  isHahaReact ? "pulse pulse-bg" : ""
                }`}
              />
            </div>
            <div
              className="reaction-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => handleReactionClick(e)}
              onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
              reaction="thanks"
            >
              <img
                src={thanksReaction}
                alt="Thanks Reaction"
                reaction="thanks"
                className={`like-reaction ${
                  isThanksReact ? "pulse pulse-bg" : ""
                }`}
              />
            </div>
            <div
              className="reaction-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => handleReactionClick(e)}
              onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
              reaction="like"
            >
              <img
                src={likeReaction}
                alt="Like Reaction"
                reaction="like"
                className={`like-reaction ${
                  isLikeReact ? "pulse pulse-bg" : ""
                }`}
              />
            </div>
            <div
              className="reaction-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => handleReactionClick(e)}
              onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
              reaction="sad"
            >
              <img
                src={sadReaction}
                alt="Sad Reaction"
                reaction="sad"
                className={`like-reaction ${
                  isSadReact ? "pulse pulse-bg" : ""
                }`}
              />
            </div>
            <div
              className="reaction-icon"
              role="button"
              tabIndex={0}
              onClick={(e) => handleReactionClick(e)}
              onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
              reaction="salute"
            >
              <img
                src={saluteReaction}
                alt="Salute Reaction"
                reaction="salute"
                className={`like-reaction ${
                  isSaluteReact ? "pulse pulse-bg" : ""
                }`}
              />
            </div>
            {specificReactions?.includes("fire") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="fire"
              >
                <img
                  src={fireReaction}
                  alt="Fire Reaction"
                  reaction="fire"
                  className={`like-reaction ${
                    isFireReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("snake") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="snake"
              >
                <img
                  src={snakeReaction}
                  alt="Snake Reaction"
                  reaction="snake"
                  className={`like-reaction ${
                    isSnakeReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("chain") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="chain"
              >
                <img
                  src={chainReaction}
                  alt="Chain Reaction"
                  reaction="chain"
                  className={`like-reaction ${
                    isChainReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("dollar") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="dollar"
              >
                <img
                  src={dollarReaction}
                  alt="Dollar Reaction"
                  reaction="dollar"
                  className={`like-reaction ${
                    isDollarReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("dragon") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="dragon"
              >
                <img
                  src={dragonReaction}
                  alt="Dragon Reaction"
                  reaction="dragon"
                  className={`like-reaction ${
                    isDragonReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("tiger") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="tiger"
              >
                <img
                  src={tigerReaction}
                  alt="Tiger Reaction"
                  reaction="tiger"
                  className={`like-reaction ${
                    isTigerReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("army") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="army"
              >
                <img
                  src={armyReaction}
                  alt="Army Reaction"
                  reaction="army"
                  className={`like-reaction ${
                    isArmyReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("truck") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="truck"
              >
                <img
                  src={truckReaction}
                  alt="Truck Reaction"
                  reaction="truck"
                  className={`like-reaction ${
                    isTruckReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("warehouse") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="warehouse"
              >
                <img
                  src={warehouseReaction}
                  alt="Warehouse Reaction"
                  reaction="warehouse"
                  className={`like-reaction ${
                    isWarehouseReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("moneybag") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="moneybag"
              >
                <img
                  src={moneybagReaction}
                  alt="Moneybag Reaction"
                  reaction="moneybag"
                  className={`like-reaction ${
                    isMoneybagReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("rooster") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="rooster"
              >
                <img
                  src={roosterReaction}
                  alt="Rooster Reaction"
                  reaction="rooster"
                  className={`like-reaction ${
                    isRoosterReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
            {specificReactions?.includes("vessel") && (
              <div
                className="reaction-icon"
                role="button"
                tabIndex={0}
                onClick={(e) => handleReactionClick(e)}
                onKeyDown={(e) => e.key === "Enter" && handleReactionClick(e)}
                reaction="vessel"
              >
                <img
                  src={vesselReaction}
                  alt="Vessel Reaction"
                  reaction="vessel"
                  className={`like-reaction ${
                    isVesselReact ? "pulse pulse-bg" : ""
                  }`}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReactionOptions;
